import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("setSaveDisabled", function satSaveDisabled(save: boolean) {
    shiftEditorViewState().disableSave = save;
});